'use strict';
import React from 'react';
import LeaveCalDetail from './leaveCalDetail';

class LeaveCal extends React.Component {
    constructor(props) {
        super(props);

    }
    static defaultProps = {
        monthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        apmTxt: ["Full", "Am", "Pm"]
    };
    shortForm(leaveTxt) {
        let shortForm = "";
        if (/annual/i.test(leaveTxt)) {
            shortForm = "AL";
        } else if (/compassionate/i.test(leaveTxt)) {
            shortForm = "CL";
        } else if (/medical/i.test(leaveTxt)) {
            shortForm = "ML";
        } else if (/time/i.test(leaveTxt)) {
            shortForm = "TO";
        } else if (/tele/i.test(leaveTxt)) {
            shortForm = "TC";
        } else if (/reservist/i.test(leaveTxt)) {
            shortForm = "RL";
        } else if (/unpaid/i.test(leaveTxt)) {
            shortForm = "UP";
        } else if (/other/i.test(leaveTxt)) {
            shortForm = "OL";
        } else if (/childcare/i.test(leaveTxt)) {
            shortForm = "CC";
        } else {
            shortForm = leaveTxt;
        }

        return shortForm;
    }
    isHoliday(year, month, date) {
        let isHoliday = false;
        let actualDay = new Date(year, month, date);
        if (this.props.holiday) {
            if (this.props.holiday.holiday) {
                let s = this.props.holiday;
                let len = s.holiday.length;
                for (let i = 0; i < len; i++) {
                    if (s.holiday[i].year == actualDay.getFullYear() && s.holiday[i].month == actualDay.getMonth() && 
                        s.holiday[i].date == actualDay.getDate()) {
                        isHoliday = true;
                        break;
                    }
                }

            }
        }

        return isHoliday;
    }
    arrangeLeave() {
        let s = this.props.leaves;
        let len = s.length;
        let newLeaves = [];
        for (let i = 0; i < len; i++) {
            //defined leave startYear
            let sd = new Date(s[i].startDate);
            let startYear = sd.getFullYear();
            let startMonth = sd.getMonth();
            let startDate = sd.getDate();

            if (s[i].type != 7) {
                let ed = new Date(s[i].endDate);
                let endYear = ed.getFullYear();
                let endMonth = ed.getMonth();
                let endDate = ed.getDate();

                let noDays = parseInt((new Date(endYear, endMonth, endDate).getTime() - new Date(startYear, startMonth, startDate).getTime()) / 1000 / 60 / 60 / 24 + 1);
                //push those date to attendance
                for (let j = 0; j < noDays; j++) {

                    let duration;

                    /*
                    leaveArray = leaveArray.concat({
                        year: new Date(startYear, startMonth, startDate + i).getFullYear(),
                        month: new Date(startYear, startMonth, startDate + i).getMonth(),
                        date: new Date(startYear, startMonth, startDate + i).getDate(),
                        staffId: leave[j].staffId,
                        type: leave[j].type,
                        leaveTxt: leave[j].leaveTxt,
                        duration: duration
                    });
                    */
                    //check if there is saturday or sunday
                    let day = new Date(startYear, startMonth, startDate + j).getDay();
                    let isHoliday = this.isHoliday(startYear, startMonth, startDate + j);
                    if (isHoliday) {
                        continue;
                    } else if (day == 0) {
                        continue;
                    } else if (j == 0 && day == 6) {
                        if (this.props.holiday.saturdayWork == 0) {
                            duration = s[i].apmStart;
                        } else if (this.props.holiday.saturdayWork == 1) {
                            duration = 1;
                        } else {
                            continue;
                        }
                    } else if (j == 0) {
                        duration = s[i].apmStart;
                    } else if (j + 1 == noDays && day == 6) {
                        if (this.props.holiday.saturdayWork == 0) {
                            duration = s[i].apmEnd;
                        } else if (this.props.holiday.saturdayWork == 1) {
                            duration = 1;
                        } else {
                            continue;
                        }

                    } else if (j + 1 == noDays) {
                        duration = s[i].apmEnd;
                    } else if (day == 6) {
                        if (this.props.holiday.saturdayWork == 0) {
                            duration = 0
                        } else if (this.props.holiday.saturdayWork == 1) {
                            duration = 1;
                        } else {
                            continue;
                        }

                    } else {
                        duration = 0;
                    }

                    let leaveTxt = this.shortForm(s[i].leaveTxt);
                    if (s[i].status == 0 || s[i].status == 3) {
                        newLeaves = newLeaves.concat({
                            year: new Date(startYear, startMonth, startDate + j).getFullYear(),
                            month: new Date(startYear, startMonth, startDate + j).getMonth(),
                            date: new Date(startYear, startMonth, startDate + j).getDate(),
                            //staffId: s[i].staffId,
                            //type: s[i].type,
                            status: s[i].status,
                            leaveTxt: s[i].submittedBy + " - " + leaveTxt + " (" + this.props.apmTxt[duration] + ")",
                            //duration: duration
                        });
                    }
                }
            } else {
                if (s[i].status == 0 || s[i].status == 3) {
                    let leaveTxt = this.shortForm(s[i].leaveTxt);

                    let isHoliday = this.isHoliday(startYear, startMonth, startDate);
                    if (isHoliday) {
                        continue;
                    }
                    newLeaves = newLeaves.concat({
                        year: new Date(startYear, startMonth, startDate).getFullYear(),
                        month: new Date(startYear, startMonth, startDate).getMonth(),
                        date: new Date(startYear, startMonth, startDate).getDate(),
                        //staffId: s[i].staffId,
                        //type: s[i].type,
                        status: s[i].status,
                        leaveTxt: s[i].submittedBy + " - " + leaveTxt + " (" + (s[i].startTime ? s[i].startTime + " ~ " + s[i].endTime : "") + ")",
                        //duration: duration
                    });
                }
            }
        }

        return newLeaves;
    }

    render() {
        let year = this.props.startYear ? this.props.startYear : new Date().getFullYear();
        let month = typeof this.props.startMonth == 'number' ? this.props.startMonth : new Date().getMonth();
       
        let start_day = new Date(year, month, 1).getDay();
       
        let last_date = new Date(year, month + 1, 0).getDate();
        let last_wk = Math.ceil((last_date + start_day) / 7);
        let newLeaves = this.arrangeLeave();
        return (
            <div className="cal-bd-wp">
                <div className="atd-bd-tt">
                    <h3><b>
                        Leave Application &nbsp;
                        ({this.props.monthTxt[this.props.startMonth] + " " + this.props.startYear})
                    </b></h3>
                </div>

                <LeaveCalDetail
                    holiday={this.props.holiday}
                    year={this.props.startYear}
                    month={this.props.startMonth}
                    newLeaves={newLeaves}
                    start_day={start_day}
                    last_date={last_date}
                    last_wk={last_wk}
                />

            </div>
        );
    }
}
export default LeaveCal;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/leaveCal.js